import { useParams } from 'react-router-dom';

import { MissionSpaceEnum } from '../app/enums/mission-space.enum';
import {
  COLLABORATION_ID_PARAM,
  isMissionSpace,
  MISSION_SPACE_PARAM,
  subMissionSpaceOf,
} from '../app/utils/mission-space.util';
import type { MissionSpacePath } from '../app/utils/mission-space.util';

// The space of the current mission page, "missions" outside of a mission page.
export const useMissionSpace = (): MissionSpacePath => {
  const {
    [MISSION_SPACE_PARAM]: missionSpace,
    [COLLABORATION_ID_PARAM]: collaborationId,
  } = useParams();

  if (collaborationId) {
    return subMissionSpaceOf(collaborationId);
  }

  return isMissionSpace(missionSpace)
    ? missionSpace
    : MissionSpaceEnum.Missions;
};
